// extracted by mini-css-extract-plugin
export default {"all-projects-container":"allProjects_all-projects-container__BpCGe","all-projects-project":"allProjects_all-projects-project__SPHig"};